var _defs, _g, _g2, _g3, _g4, _text, _g5, _g6, _g7, _g8, _g9, _text2, _g10, _text3, _g11, _text4, _g12, _g13, _text5, _g14, _g15, _text6, _g16, _text7, _g17, _g18, _font, _text8, _g19, _font2, _text9, _g20, _font3, _text10, _g21, _font4, _text11, _g22, _g23, _br, _text12, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactTreePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "581px",
    height: "402px",
    viewBox: "-0.5 -0.5 581 402",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2024-05-20T08:49:12.528Z\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:125.0) Gecko/20100101 Firefox/125.0\" etag=\"jmtAEwrGYXxPyKCtdF3b\" version=\"24.4.4\" type=\"device\"> <diagram name=\"\\u0421\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 \\u2014 1\" id=\"JTRB6-uOk0P16DuqgOcf\"> <mxGraphModel dx=\"876\" dy=\"925\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-17\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-3\" target=\"cZhvCwIh98rEkF0zMbZA-6\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-18\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-3\" target=\"cZhvCwIh98rEkF0zMbZA-5\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-30\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-3\" target=\"cZhvCwIh98rEkF0zMbZA-29\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-3\" value=\"&lt;p&gt;&lt;b&gt;&lt;font face=&quot;Verdana&quot; style=&quot;font-size: 15px;&quot;&gt;App&lt;/font&gt;&lt;/b&gt;&lt;/p&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"384\" y=\"40\" width=\"60\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-20\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-4\" target=\"cZhvCwIh98rEkF0zMbZA-7\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-21\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-4\" target=\"cZhvCwIh98rEkF0zMbZA-8\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-23\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;exitX=0.5;exitY=1;exitDx=0;exitDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-4\" target=\"cZhvCwIh98rEkF0zMbZA-10\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-24\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;exitX=0.5;exitY=1;exitDx=0;exitDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-4\" target=\"cZhvCwIh98rEkF0zMbZA-9\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-4\" value=\"&lt;font style=&quot;font-size: 15px;&quot; face=&quot;Verdana&quot;&gt;Employees&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"364\" y=\"200\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-5\" value=\"&lt;font style=&quot;font-size: 15px;&quot; face=&quot;Verdana&quot;&gt;About&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;glass=0;shadow=0;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"170\" y=\"120\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-6\" value=\"&lt;font face=&quot;Verdana&quot; style=&quot;font-size: 15px;&quot;&gt;Header&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"560\" y=\"120\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-25\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-7\" target=\"cZhvCwIh98rEkF0zMbZA-11\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-7\" value=\"&lt;font style=&quot;font-size: 12px;&quot; face=&quot;Verdana&quot;&gt;EmployeesCards&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"274\" y=\"320\" width=\"120\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-26\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-8\" target=\"cZhvCwIh98rEkF0zMbZA-13\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-8\" value=\"&lt;font style=&quot;font-size: 12px;&quot; face=&quot;Verdana&quot;&gt;EmployeesGroups&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"424\" y=\"320\" width=\"120\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-9\" value=\"&lt;font style=&quot;font-size: 12px;&quot; face=&quot;Verdana&quot;&gt;EmployeesForm&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"124\" y=\"320\" width=\"120\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-27\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-10\" target=\"cZhvCwIh98rEkF0zMbZA-14\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-10\" value=\"&lt;font face=&quot;Verdana&quot;&gt;EmployeeTable&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"574\" y=\"320\" width=\"130\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-11\" value=\"&lt;font face=&quot;Verdana&quot;&gt;EmployeeCard&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"274\" y=\"400\" width=\"120\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-13\" value=\"&lt;font face=&quot;Verdana&quot;&gt;EmployeeGroup&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"424\" y=\"400\" width=\"120\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-14\" value=\"&lt;font face=&quot;Verdana&quot;&gt;EmployeeRow&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"574\" y=\"400\" width=\"130\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-31\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"cZhvCwIh98rEkF0zMbZA-29\" target=\"cZhvCwIh98rEkF0zMbZA-4\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"cZhvCwIh98rEkF0zMbZA-29\" value=\"&lt;div&gt;&lt;font style=&quot;font-size: 15px;&quot; face=&quot;Verdana&quot;&gt;Employees&lt;/font&gt;&lt;/div&gt;&lt;div&gt;&lt;font style=&quot;font-size: 15px;&quot; face=&quot;Verdana&quot;&gt;Container&lt;br&gt;&lt;/font&gt;&lt;/div&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"364\" y=\"120\" width=\"100\" height=\"40\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 320 21.06 L 486 21.06 L 486 74.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 486 79.88 L 482.5 72.88 L 486 74.63 L 489.5 72.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 260 21.06 L 96 21.06 L 96 74.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96 79.88 L 92.5 72.88 L 96 74.63 L 99.5 72.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 290 41 L 290 74.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 290 79.88 L 286.5 72.88 L 290 74.63 L 293.5 72.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 1,
    width: 60,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 21,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 15
    },
    face: "Verdana"
  }, "App"))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 25,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "App"))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 290 201 L 290 241.06 L 210 241.06 L 210 274.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 210 279.88 L 206.5 272.88 L 210 274.63 L 213.5 272.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 290 201 L 290 241.06 L 360 241.06 L 360 274.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360 279.88 L 356.5 272.88 L 360 274.63 L 363.5 272.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 290 201 L 290 241.06 L 515.06 241.06 L 515.01 274.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 515 279.88 L 511.51 272.88 L 515.01 274.63 L 518.51 272.89 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 290 201 L 290 241.06 L 60 241.06 L 60 274.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60 279.88 L 56.5 272.88 L 60 274.63 L 63.5 272.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 161,
    width: 100,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 181,
      marginLeft: 241
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 15
    }
  }, "Employees"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 185,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Employees"))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 81,
    width: 100,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 101,
      marginLeft: 47
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 15
    }
  }, "About"))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 105,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "About"))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 81,
    width: 100,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 101,
      marginLeft: 437
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 15
    },
    face: "Verdana"
  }, "Header"))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 105,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Header"))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 210 321 L 210 354.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 210 359.88 L 206.5 352.88 L 210 354.63 L 213.5 352.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 281,
    width: 120,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 301,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 12
    }
  }, "EmployeesCards"))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 305,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeesCards"))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 360 321 L 360 354.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360 359.88 L 356.5 352.88 L 360 354.63 L 363.5 352.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 281,
    width: 120,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 301,
      marginLeft: 301
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 12
    }
  }, "EmployeesGroups"))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 305,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeesGroups"))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 281,
    width: 120,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 301,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 12
    }
  }, "EmployeesForm"))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 305,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeesForm"))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 515 321 L 515 354.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 515 359.88 L 511.5 352.88 L 515 354.63 L 518.5 352.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 281,
    width: 130,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 301,
      marginLeft: 451
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font || (_font = /*#__PURE__*/React.createElement("font", {
    face: "Verdana"
  }, "EmployeeTable")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 305,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeeTable"))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 361,
    width: 120,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 381,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    face: "Verdana"
  }, "EmployeeCard")))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 385,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeeCard"))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 361,
    width: 120,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 381,
      marginLeft: 301
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font3 || (_font3 = /*#__PURE__*/React.createElement("font", {
    face: "Verdana"
  }, "EmployeeGroup")))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 385,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeeGroup"))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 361,
    width: 130,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 381,
      marginLeft: 451
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font4 || (_font4 = /*#__PURE__*/React.createElement("font", {
    face: "Verdana"
  }, "EmployeeRow")))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 385,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "EmployeeRow"))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 290 121 L 290 154.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 290 159.88 L 286.5 152.88 L 290 154.63 L 293.5 152.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 81,
    width: 100,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 101,
      marginLeft: 241
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 15
    }
  }, "Employees")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("font", {
    face: "Verdana",
    style: {
      fontSize: 15
    }
  }, "Container", _br || (_br = /*#__PURE__*/React.createElement("br", null)))))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 105,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Employees...")))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactTreePic);
export default __webpack_public_path__ + "static/media/reactTreePic.8cc38609bc09a5b250a577c18fd90b50.svg";
export { ForwardRef as ReactComponent };